import { useEffect, useState } from "react";
import { Loader2, Monitor, Unlink } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }) : "");

function LicenceRow({ lic, admin, onUpdate }) {
  const [busy, setBusy] = useState(null);
  const free = async (m) => {
    if (!window.confirm(`Free machine ${m} on this ${lic.product} licence?`)) return;
    setBusy(m);
    try { const { data } = await admin.post(`/licences/${lic.id}/machines/remove`, { machine_id: m }); onUpdate(data); } catch { /* noop */ }
    setBusy(null);
  };
  return (
    <div className="border border-[#2a2f3d] px-3 py-2 space-y-1" data-testid={`customer-licence-${lic.key_hint}`}>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="uppercase font-semibold text-white">{lic.product}</span>
        <span className="font-mono text-[#9ba3b4]">•••{lic.key_hint}</span>
        <span className={`chip ${lic.status === "active" ? "" : "text-[#ff453a] border-[#ff453a]"}`}>{lic.status}</span>
        <span className="text-[#5c6479]">{lic.source} · {when(lic.created_at)}</span>
        {lic.product !== "genalpha" && <span className="ml-auto font-mono text-[#9ba3b4]">{lic.machines.length}/3 machines · {lic.removals_left} self-removals left</span>}
      </div>
      {lic.machines.map((m) => (
        <div key={m} className="flex items-center gap-2 text-xs pl-2">
          <Monitor size={12} className="text-[#5c6479]" /><span className="font-mono">{m}</span>
          <button onClick={() => free(m)} disabled={!!busy} className="btn-ghost px-2 py-0.5 text-[11px] flex items-center gap-1 ml-auto" data-testid={`customer-free-${lic.key_hint}-${m}`}>
            {busy === m ? <Loader2 className="spin" size={11} /> : <Unlink size={11} />} free slot
          </button>
        </div>
      ))}
    </div>
  );
}

export const CustomerPanel = ({ email, admin }) => {
  const [data, setData] = useState(null);
  useEffect(() => { admin.get("/customer", { params: { email } }).then((r) => setData(r.data)).catch(() => setData({ licences: [], purchases: [] })); }, [admin, email]);
  if (!data) return <Loader2 className="spin text-[#e69d27]" size={14} />;
  const update = (d) => setData((s) => ({ ...s, licences: s.licences.map((l) => (l.id === d.id ? d : l)) }));
  return (
    <div className="border border-dashed border-[#e69d27]/50 p-3 space-y-3" data-testid="customer-panel">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#e69d27]">Customer · {email}</div>
      <div className="space-y-1" data-testid="customer-purchases">
        {data.purchases.length === 0 && <p className="text-xs text-[#5c6479]">No purchases with this email.</p>}
        {data.purchases.map((p) => (
          <div key={p.session_id} className="flex flex-wrap gap-2 text-xs" data-testid={`customer-purchase-${p.session_id}`}>
            <span className="text-white">{p.label}</span><span className="font-mono">€{p.amount}</span>
            <span className={p.payment_status === "paid" ? "text-[#a3ff4f]" : "text-[#9ba3b4]"}>{p.payment_status}</span>
            <span className="ml-auto text-[#5c6479]">{when(p.created_at)}</span>
          </div>
        ))}
      </div>
      <div className="space-y-2" data-testid="customer-licences">
        {data.licences.length === 0 && <p className="text-xs text-[#5c6479]">No licences with this email.</p>}
        {data.licences.map((l) => <LicenceRow key={l.id} lic={l} admin={admin} onUpdate={update} />)}
      </div>
    </div>
  );
};
